import { render, staticRenderFns } from "./BoardBackgorund.vue?vue&type=template&id=06b19efc&"
import script from "./BoardBackgorund.vue?vue&type=script&lang=js&"
export * from "./BoardBackgorund.vue?vue&type=script&lang=js&"
import style0 from "./BoardBackgorund.vue?vue&type=style&index=0&id=06b19efc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports